import { render, staticRenderFns } from "./EditLeaderboardQuestionLimitConfirmationDialog.vue?vue&type=template&id=6e665e56"
import script from "./EditLeaderboardQuestionLimitConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./EditLeaderboardQuestionLimitConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports